<script lang="ts" setup>
    import { computed } from "vue";

    const props = defineProps({
        icon: {
            required: true,
            type: String
        },

        duotone: {
            default: false,
            type: Boolean
        },
        opacity: {
            default: 0.333,
            type: [Number, String]
        }
    });

    const styles = computed((): Record<string, string> => ({
        "fill": props.duotone ? "currentColor" : "none",
        "fill-opacity": props.duotone ? `${props.opacity}` : "0"
    }));
</script>

<template>
    <svg class="feather-icon" :style="styles">
        <use :href="`/assets/feather-sprite.svg#${icon}`" />
    </svg>
</template>

<style lang="scss" scoped>
    .feather-icon
    {
        height: 1em;
        stroke: currentColor;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        width: 1em;
    }
</style>
